import { ListItemIcon, ListItemIconProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type RowMenuItemIconProps = ListItemIconProps & {
    icon: React.ReactNode
}

export function RowMenuItemIcon ({ icon, ...props }: RowMenuItemIconProps) {
    const cls = useStyles();
    
    return (
        <ListItemIcon className={cls.root} {...props}>
            { icon }
        </ListItemIcon>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: theme.spacing(4)
    }
}));